

<div class="card" style="margin-bottom:0px !important;">
  <div class="card-body" style="padding-top:unset !important;">
    <div class="pb-2">
      <h5 class="card-title text-center pb-0 fs-4"><div><i class="bi bi-dash-circle"></i></div>Внимание</h5>
      <p class="text-center small">За съжаление, действието беше не успешно! Моля свържете се с Администратор.</p>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-secondary w-100" (click)="closeModal()">Затвори</button>
      </div>
    </div>
  </div>
</div>
